import React from "react";

/**
 * Reusable news headline ticker. Renders the marquee track with gradient fade edges.
 * Used inline in the navbar (position=top) or as a fixed footer bar (position=bottom).
 */
export default function NewsTicker({ headlines, variant = "navbar" }) {
  if (!headlines?.length) return null;

  const fadeColor = variant === "footer" ? "rgb(0,0,0)" : "rgb(6,7,43)";

  return (
    <div className="overflow-hidden relative w-full h-full" data-testid="news-ticker">
      <div
        style={{
          position: "absolute", left: 0, top: 0, bottom: 0, width: "48px",
          background: `linear-gradient(to right, ${fadeColor}, transparent)`,
          zIndex: 2, pointerEvents: "none", borderRadius: "4px 0 0 4px",
        }}
      />
      <div
        style={{
          position: "absolute", right: 0, top: 0, bottom: 0, width: "48px",
          background: `linear-gradient(to left, ${fadeColor}, transparent)`,
          zIndex: 2, pointerEvents: "none", borderRadius: "0 4px 4px 0",
        }}
      />
      <div className="news-ticker-track">
        {[...headlines, ...headlines].map((h, i) => (
          <a
            key={`${h.link}-${i}`}
            href={h.link}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 whitespace-nowrap mx-6 text-xs hover:text-[#A3E635] transition-colors cursor-pointer"
            style={{ textDecoration: "none" }}
            data-testid="news-ticker-headline"
          >
            <span className="text-white/30 font-semibold uppercase" style={{ fontSize: "9px" }}>
              {h.source}
            </span>
            <span className="text-white/50 hover:text-[#A3E635]/80">{h.title}</span>
          </a>
        ))}
      </div>
    </div>
  );
}
